<template>
  <div class="device-status-control">
    <el-tooltip :content="getStatusTooltip()" placement="top" :open-delay="500">
      <el-tag :type="statusInfo.type" size="medium">
        {{ statusInfo.label }}
      </el-tag>
    </el-tooltip>
  </div>
</template>

<script>
import { DEVICE_STATUS } from '@/config/device-constants'

export default {
  name: 'DeviceStatusControl',
  props: {
    status: {
      type: String,
      default: 'offline'
    },
    deviceId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      deviceStatus: DEVICE_STATUS,
      currentStatus: this.status
    }
  },
  computed: {
    statusInfo() {
      // 只处理在线和离线两种状态
      if (this.currentStatus === 'online') {
        return {
          value: 'online',
          label: '在线',
          type: 'success'
        }
      } else {
        // 默认为离线状态
        return {
          value: 'offline',
          label: '离线',
          type: 'danger'
        }
      }
    }
  },
  watch: {
    status(newStatus) {
      // 只接受在线或离线两种状态
      if (newStatus === 'online' || newStatus === 'offline') {
        this.currentStatus = newStatus
      } else {
        this.currentStatus = 'offline'
      }
    }
  },
  methods: {
    getStatusTooltip() {
      const statusMap = {
        'online': '设备正常在线运行',
        'offline': '设备已离线，请检查连接'
      }
      return statusMap[this.currentStatus] || '设备状态未知'
    }
  }
}
</script>

<style scoped>
.device-status-control {
  display: flex;
  align-items: center;
}
</style> 